answers = [{
    "topic": "operation",
    "title": "How can I switch on Aidel using its eye tracking feature?",
    "description": "A simple one-eye blink toward the camera located in the lamp boom will switch on the device."
},{
    "topic": "operation",
    "title": "How can I switch on Aidel using hand gestures?",
    "description": "A simple 'thumb up' gesture toward the camera located in the lamp boom will switch on the device."
},{
    "topic": "operation",
    "title": "How can I switch on Aidel using touch commands?",
    "description": "Tap either strip on the left or right located at the base to switch on or off the device."
},{
    "topic": "operation",
    "title": "Can I allow the lamp use to only specific people?",
    "description": "Yes, it's possible to allow or block interactions from specific people. This feature can be personalized using our app."
},{
    "topic": "operation",
    "title": "Can I personalize the eye tracking interaction?",
    "description": "Yes, download our app to customize the way you interact with the lamp."
},{
    "topic": "operation",
    "title": "Can I personalize the gestures interaction?",
    "description": "Yes, download our app to customize the gesture commands."
},{
    "topic": "app",
    "title": "Where can I find your app?",
    "description": "Our app is available in the App store and in the Play store."
},{
    "topic": "app",
    "title": "Is your app free?",
    "description": "Our app is free of charge and ad-free for Aidel purchasers."
},{
    "topic": "product",
    "title": "Can you customize the lamp in more ways than provided in the shop?",
    "description": "Yes, we are able to customize some parts, mostly the colors. Contact us to know more about what is possible to tailor and a free quote."
},{
    "topic": "product",
    "title": "Which kind of power plug your product has?",
    "description": "We bundle the power plug standard to the country you specified in the shipping address."
},{
    "topic": "product",
    "title": "What is the typical lifetime of your product?",
    "description": "Aidel has been lab tested to survive more than 15 years in normal environment conditions."
},{
    "topic": "product",
    "title": "How safe is your product?",
    "description": "We went through numerous certifications bodies from all over the world. This means that Aidel is reliable and safe."
},{
    "topic": "product",
    "title": "What are the offline functionalities?",
    "description": "Eye and gesture tracking are functions that work also offline. For further customization, e.g. track only specific people, you will need online access as is done through our app."
},{
    "topic": "product",
    "title": "What are the online functionalities?",
    "description": "Check our manual."
},{
    "topic": "shipping",
    "title": "How long will take to prepare my order?",
    "description": "We are continually striving to prepare your order in the best way. It usually takes us one to two working days."
},{
    "topic": "shipping",
    "title": "How long will it take to receive my order?",
    "description": "There are two main factors influencing how long your order will take to reach your destination: one is the preparation time, under our control, and the other is the delivery time, which depends on the delivery service you selected at the checkout page."
},{
    "topic": "warranty",
    "title": "I have received a defective product, what can I do?",
    "description": "Our product are thoroughly tested. In the remote case you received a defective product feel free to contact us to solve the issue."
},
]